import { SeatInfo } from 'components/PaymentSummary'
import messages from 'i18n/messages'
import first from 'lodash/first'
import sortBy from 'lodash/sortBy'
import flowRight from 'lodash/flowRight'
import { makeSelectCurOrg } from 'logic/orgs'
import { makeSelectSeatsByIds } from 'logic/seats'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import PropTypes from 'prop-types'
import { sortSeats } from '../lib/misc'


const SeatShortInfo = ({ date, seat, pos }) => (
  <small>
    Ticket {pos}:&nbsp;
    {date.show_section_seat_info
      ? <span>
          {seat.sec_name
            ? `${seat.sec_name}`
            : <FormattedMessage {...messages.secNum} values={{ num: seat.sec_num }} />
          },&nbsp;
        </span>
      : null
    }
    {seat.sgr_name || <FormattedMessage {...messages.seatRow} />}&nbsp;
    {seat.sgr_num},&nbsp;
    <FormattedMessage {...messages.seatNum} values={{ num: seat.override_num }} />
  </small>
)

const SeatShortInfos = ({ seats, date }) => (
  <span>
    {seats.map((seat, index) =>
      <div key={`seat-${seat.id}-${index}`}>
        <SeatShortInfo pos={index + 1} seat={seat} date={date} />&nbsp;
      </div>
    )}

  </span>
)
class OfferItemInfo extends Component {

  static propTypes = {
    date: PropTypes.object.isRequired,
  }

  render() {
    const { date } = this.props
    const seats = sortBy(this.props.seats, sortSeats)
    if (!seats) return <></>

    if (seats.length < 1) return <></>

    if (seats.length < 1 || !first(seats).sgr_name)
      return (
        <div className="small-offer">
          {date.spl_enabled
            ? <SeatShortInfos seats={seats} date={date} />
            : <FormattedMessage {...messages.amountSeats} values={{ count: seats.length }} />}
        </div>
      )

    return seats.map(seat => <div key={seat.id}><SeatInfo seat={seat} /></div>)
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  seats: makeSelectSeatsByIds(props => props.offer.seat_ids),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(OfferItemInfo)
